import React from 'react';
interface FooterProps {
  onOpenModal: (modalId: 'privacy' | 'terms' | 'disclaimer') => void;
}
export function Footer({
  onOpenModal
}: FooterProps) {
  return <footer className="bg-[#2A1F17] text-[rgba(250,247,242,0.6)] py-10 px-5 text-center font-sans text-sm" data-id="element-141">
      <div className="font-serif text-xl text-[#FAF7F2] mb-2" data-id="element-142">B.E.BE 365</div>
      <div className="mb-6 italic" data-id="element-143">
        Del instinto de supervivencia al diseño de desarrollo cognitivo de élite
      </div>

      <nav aria-label="Enlaces legales" className="flex justify-center items-center gap-4 flex-wrap mb-5" data-id="element-144">
        <button onClick={() => onOpenModal('privacy')} className="text-[rgba(250,247,242,0.6)] bg-transparent border-none text-sm font-sans transition-colors hover:text-[#FAF7F2] underline underline-offset-2 min-h-[44px] flex items-center cursor-pointer" data-id="element-145">
          Política de Privacidad
        </button>
        <span className="text-[rgba(250,247,242,0.2)]" aria-hidden="true" data-id="element-146">
          |
        </span>
        <button onClick={() => onOpenModal('terms')} className="text-[rgba(250,247,242,0.6)] bg-transparent border-none text-sm font-sans transition-colors hover:text-[#FAF7F2] underline underline-offset-2 min-h-[44px] flex items-center cursor-pointer" data-id="element-147">
          Términos de Servicio
        </button>
        <span className="text-[rgba(250,247,242,0.2)]" aria-hidden="true" data-id="element-148">
          |
        </span>
        <button onClick={() => onOpenModal('disclaimer')} className="text-[rgba(250,247,242,0.6)] bg-transparent border-none text-sm font-sans transition-colors hover:text-[#FAF7F2] underline underline-offset-2 min-h-[44px] flex items-center cursor-pointer" data-id="element-149">
          Descargo de Responsabilidad
        </button>
      </nav>

      {/* Mobile-only urgency message */}
      <div className="md:hidden text-sm text-[#B76E79] font-bold mb-4" data-id="element-150">
        <strong data-id="element-151">El Acceso Expira Pronto.</strong> El Primer Año de tu Bebé No
        Esperará.
      </div>

      <div className="text-sm text-[rgba(250,247,242,0.4)] mb-5" data-id="element-152">
        © 2026 B.E.BE 365. Todos los derechos reservados.
      </div>

      <div className="max-w-[700px] mx-auto text-xs text-[rgba(250,247,242,0.3)] leading-relaxed" data-id="element-153">
        Este sitio no es parte del sitio web de Facebook™ ni de Meta Platforms
        Inc. Además, este sitio NO está respaldado por Facebook™ de ninguna
        manera. FACEBOOK™ es una marca comercial de META PLATFORMS, INC. Los
        resultados mencionados no son típicos. Los resultados individuales
        variarán según el esfuerzo, la experiencia y la situación de cada
        familia. Este contenido es únicamente para fines educativos e
        informativos. Siempre consulta a tu pediatra para decisiones médicas.
      </div>
    </footer>;
}